module.exports = __webpack_public_path__ + "img/drgn.472972ed.svg";